<template>
  <svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M5 0C2.2435 0 0 2.24325 0 5C0 7.75675 2.2435 10 5 10C7.75725 10 10 7.75675 10 5C10 2.24325 7.75725 0 5 0ZM7.2045 4.46875L5.064 6.60975C4.915 6.7585 4.71975 6.833 4.5245 6.833C4.32975 6.833 4.13425 6.7585 3.9855 6.60975L2.796 5.42025C2.49825 5.1225 2.49825 4.63925 2.796 4.342C3.09375 4.044 3.57625 4.044 3.8745 4.342L4.5245 4.992L6.1265 3.39025C6.4235 3.093 6.90725 3.093 7.2045 3.39025C7.5025 3.688 7.5025 4.171 7.2045 4.46875Z"
        fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: "IconRoundTick"
}
</script>

<style scoped>

</style>